import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart'; 
import Footer from './components/Footer';
import Success from './pages/Success';
import './App.css';
import { FaShoppingCart } from "react-icons/fa";
import { useContext } from "react";
import { CartContext } from "./context/CartContext";

function App() {
  const { cart } = useContext(CartContext);
  const cartCount = cart.length;

  return (
    <Router>
        <nav className="navbar">
          <Link to="/" className="site-name">owen studio</Link> {/* Make site name clickable */}
          <div className="nav-links">
            <Link to="/">home</Link>
            <span className="nav-separator">;</span>
            <Link to="/about">about me</Link>
            <span className="nav-separator">;</span>
            <Link to="/shop">shop</Link>
            {/* <span className="nav-separator">;</span> */}
            <Link to="/cart" className="cart-link">
              <FaShoppingCart className="cart-icon" />
              {cartCount > 0 && (
                <span className="cart-badge">{cartCount}</span>
              )}
          </Link>
          </div>
        </nav>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:productId" element={<ProductDetail />} /> {/* new */}
          <Route path="/cart" element={<Cart />} /> 
          <Route path="/success" element={<Success />} />
        </Routes>
        <Footer />
    </Router>
  );
}

export default App;